var render = function render(){var _vm=this,_c=_vm._self._c;return _c('data-chip',{attrs:{"text":_vm.dutyType.title,"iconLeft":_vm.dutyType.icon,"color":_vm.dutyType.color,"small":_vm.small}})
}
var staticRenderFns = []

export { render, staticRenderFns }